
export default {
  // Common
  "language": "Language",
  "language_description": "Change the language used throughout the application",
  "save_language": "Save Language Preference",
  "updating": "Updating...",
  "return_home": "Return Home",
  "sign_out": "Sign Out",
  "sign_out_success": "Signed out successfully",
  "error": "Error",
  "loading": "Loading...",
  "cancel": "Cancel",
  "save": "Save",
  "edit": "Edit",
  "delete": "Delete",
  "back": "Back",
  "view_details": "View Details",
  "not_applicable": "N/A",
  "invalid_date": "Invalid date",
  "name": "Name",
  "qty": "Qty",
  "actions": "Actions",
  "sort_by": "Sort by",
  "filter_by": "Filter by",
  "ascending": "Ascending",
  "descending": "Descending",
  "date_added": "Date Added",
  "retry": "Retry",
  "with": "with",
  "or": "or",
  "format": "format",
  "username": "Username",
  "phone_number": "Phone Number",
  "email": "Email",
  "change": "Change",
  "save_changes": "Save Changes",
  "sign_in": "Sign In",
  "sign_up": "Sign Up",
  "sign_in_to_review": "Sign In to Add a Review",
  "password": "Password",
  "email_address": "Email Address",
  "forgot_password": "Forgot Password?",
  "processing": "Processing...",
  "sign_in_success": "Successfully signed in!",
  "already_have_account": "Already have an account? Sign in",
  "dont_have_account": "Don't have an account? Sign up",
  "completing_sign_in": "Completing sign in",
  "please_wait": "Please wait...",
};
